import { RowCrudStatus } from "../../common/types";
import { SignedContract } from "../../../api/graphql";
import { LangStore } from "../../../store";

export type SignedContractValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  data_: any;
  originalId_: string;
};

export type SignedContractErrorsType = {
  data_?: { message: string; fieldLabel: string };
  originalId_?: { message: string; fieldLabel: string };
};

export function SignedContractValuesInit(): SignedContractValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    data_: "{}",
    originalId_: "",
  };
}

export type SignedContractType = SignedContract | SignedContractValuesType;

export function signedContractDisplayId(
  source: Partial<SignedContract>,
  _langStore: LangStore
) {
  return source.data_?.contractNumber ?? _langStore.emptyStringSymbol;
}

export function getSignedContractValues(
  source: SignedContractType,
  _langStore: LangStore,
  _duplicated: boolean = false
): SignedContractValuesType {
  const entityValues = SignedContractValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : signedContractDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.data_ = source.data_;
  entityValues.originalId_ = source.originalId_;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
